import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SERVER_URL } from './../config/contants';
import { API_TOKEN } from './../config/contants';
import { LocalStorageProvider } from '../providers/local-storage';
import { FCM } from '@ionic-native/fcm';
import { Platform } from 'ionic-angular';
import { Componentes } from './componentes';
import { HttpHeaders } from '@angular/common/http'; 

@Injectable()
export class PushProvider {

  token: string
  os: string
  registrado: false

  constructor(public http: HttpClient, private localStorage: LocalStorageProvider, private fcm: FCM, public platform: Platform, private componentes: Componentes) {

  }

  registerDevice(token, os, usuario_id) {
    return new Promise((resolve, reject) => {
      let body = new FormData();
      body.append('device', token);
      body.append('guid', os);
      body.append('usuario_id', usuario_id);

      this.http.post(SERVER_URL + 'push/registrarPush', body, { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            this.setPushToken(token)
            this.setPushOs(os)
            resolve(data)
          },
          err => {
            reject(err)
          }
        )
    })
  }

  unregisterDevice(usuario_id) {
    return new Promise((resolve, reject) => {

      let body = new FormData();
      body.append('device', this.getPushtoken());
      body.append('usuario_id', usuario_id);

      this.http.post(SERVER_URL + 'push/removerPush', body, { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            resolve(data)
          },
          err => {
            reject(err)
          })
    })
  }

  setPushToken(token): void {
    this.token = token
  }

  setPushOs(os): void {
    this.os = os
  }

  getPushtoken(): string {
    return this.token
  }

  getPushOs(): string {
    return this.os
  }

  setRegistrado(valor): void {
    this.registrado = valor
  }

  getRegistrado(): boolean {
    return this.registrado
  }

  saveConfig(notificacao) {
    let configuracao = { 'notificacoes': notificacao }
    this.localStorage.storageSave('config', configuracao)
  }

  getConfig() {
    return this.localStorage.storageGet('config')
  }

  fcmSubscribe(topic, usuario_id) {

    if (this.platform.is('cordova')) {
      this.fcm.subscribeToTopic(topic)

      let plataforma = (this.platform.is('ios') ? 'ios' : 'android')

      this.fcm.getToken().then(token => {
        this.registerDevice(token, plataforma, usuario_id).then(
          data => {
          }, error => {
          }
        )
      })

      this.fcm.onTokenRefresh().subscribe(token => {
        this.registerDevice(token, plataforma, usuario_id)
      })

      this.fcm.onNotification().subscribe(data => {
        this.componentes.apresentaAlerta(data.descricao, data.titulo)
      })
    }
  }

  fcmUnsubscribe(topic, usuario_id) {

    if (this.platform.is('cordova')) {
      this.fcm.unsubscribeFromTopic(topic)
      this.unregisterDevice(usuario_id)
    }

  }

}


// WEBPACK FOOTER //
// ./src/providers/push.ts